module.exports = __webpack_public_path__ + "static/media/classic_nia.70b5a7ea.png";